var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvSamsungStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_6199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8168 7.01817C20.0517 8.792 19.9936 9.99996 19.9936 9.99996C19.9936 9.99996 20.0517 11.2077 19.8168 12.9813C19.5705 14.8378 18.9133 16.5212 17.7541 17.754L17.754 17.7542C16.5216 18.9127 14.8389 19.5703 12.9816 19.8167C11.2078 20.0516 10 19.9937 10 19.9937C10 19.9937 8.79208 20.0516 7.01849 19.8167C5.16135 19.5703 3.47843 18.9127 2.24609 17.7542L2.2459 17.754C1.08691 16.5212 0.429507 14.8389 0.183385 12.9813C-0.051726 11.2077 0.0063502 10.0004 0.0063502 10.0004C0.0063502 10.0004 -0.051726 8.792 0.183385 7.01817C0.429508 5.16122 1.08691 3.47828 2.24585 2.24593H2.24604C3.47859 1.08698 5.16107 0.429785 7.01843 0.183227C8.79224 -0.0518871 9.99997 0.00640556 9.99997 0.00640556C9.99997 0.00640556 11.2077 -0.0518871 12.9815 0.183227C14.8386 0.429568 16.5216 1.08677 17.7539 2.24593H17.7541C18.9132 3.47828 19.5705 5.161 19.8168 7.01817Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.089 12.2699C10.544 10.8982 6.77902 10.2709 6.31614 8.10513C6.20465 7.57355 6.21591 7.14897 6.29249 6.67257C6.57404 4.94719 8.11471 4.32438 9.99999 4.32438C11.5012 4.32438 13.5735 4.68478 13.5735 6.99355V7.73798H10.9302C10.9302 7.73798 10.9302 7.27848 10.9302 7.08364C10.9302 6.50476 10.5642 6.12184 9.94481 6.12184C9.28147 6.12184 9.04947 6.49463 8.97626 6.83249C8.95149 6.953 8.93684 7.17825 8.98752 7.3911C9.2871 8.63221 13.3099 9.29443 13.757 11.5131C13.801 11.7395 13.8967 12.3386 13.7683 13.2542C13.5172 15.0202 11.9382 15.6756 10.0214 15.6756C8.02799 15.6756 6.16748 14.9627 6.16748 12.5999L6.16974 11.7789H9.0123V12.8049C9.0123 13.3871 9.41549 13.7678 10.08 13.7678C10.785 13.7678 11.0237 13.4085 11.1127 13.056C11.1611 12.8567 11.1927 12.5267 11.089 12.2699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_6199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvSamsungStore);
export default __webpack_public_path__ + "static/media/ctv_samsung_store.8fe0c128112a0175f7c6e9167ce70d1a.svg";
export { ForwardRef as ReactComponent };